import IMask from "imask/esm/imask.js";
import { getLocaleDateFormat, parseDateRange, DATE_RANGE_DELIMITER } from "../dates.js";
import { concatClasses } from "../../../helpers/concatClasses/index.js";
const getTimespanClasses = ({ disabled }) => {
  const classes = ["flex items-center gap-12"];
  classes.push(disabled ? "text-neutral-400" : "text-neutral-700");
  return concatClasses(classes);
};
const getMaskFormat = (dateFormat, mode) => mode === "single" ? dateFormat : `${dateFormat} - ${dateFormat}`;
const getDisplayPlaceholder = (locale, mode) => getMaskFormat(getLocaleDateFormat(locale), mode).toLocaleLowerCase();
const parseDateRangeFromInput = (value, locale, mode) => {
  const formatString = getLocaleDateFormat(locale);
  if (!value || value === getMaskFormat(formatString, mode).toLocaleLowerCase()) {
    return [];
  }
  return parseDateRange(value, formatString, DATE_RANGE_DELIMITER);
};
const getMaskOptions = (locale, mode) => {
  return {
    mask: getMaskFormat(getLocaleDateFormat(locale), mode),
    lazy: true,
    overwrite: true,
    blocks: {
      // Max values are intentionally 'incorrect', to allow overwriting any date without friction (e.g 07 month to 11 from left to right).
      // The actual dates are being validated by date input component
      dd: { mask: IMask.MaskedRange, placeholderChar: "d", from: 1, to: 39, maxLength: 2 },
      MM: { mask: IMask.MaskedRange, placeholderChar: "m", from: 1, to: 19, maxLength: 2 },
      yyyy: {
        mask: IMask.MaskedRange,
        placeholderChar: "y",
        from: 1e3,
        to: 2999,
        maxLength: 4
      }
    }
  };
};
export {
  getDisplayPlaceholder,
  getMaskOptions,
  getTimespanClasses,
  parseDateRangeFromInput
};
